"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getYouTubeUrl;

function getYouTubeUrl(url) {
  var longOrShareUrl = /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/;
  var match = url.match(longOrShareUrl);
  var videoId = match && match[1];
  return videoId && "https://youtube.com/embed/".concat(videoId);
}